import { useState } from "react";
import { ChevronsUpDown, PackageSearch } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { sizeText } from "@/lib/catalog";

const LABEL = { sku: "Catalog · SKU match", size: "Catalog · size match", picked: "Catalog · picked", default: "No match · type default", none: "No catalog match" };

export function CatalogPicker({ row, items, idx, onPick }) {
  const [open, setOpen] = useState(false);
  const list = items.filter((c) => c.type_id === row.type_id);
  const m = row.catalog_match || "none";
  const bad = m === "none" || m === "default";
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button data-testid={`catalog-picker-button-${idx}`} title="Choose a catalog item"
          className={`mx-2 mt-0.5 inline-flex max-w-[190px] items-center gap-1 rounded-full border px-2 py-0.5 text-[10px] font-semibold transition-colors ${bad ? "border-red-500/40 bg-red-500/10 text-red-300 hover:bg-red-500/20" : "border-emerald-500/40 bg-emerald-500/10 text-emerald-300 hover:bg-emerald-500/20"}`}>
          <PackageSearch className="h-3 w-3 shrink-0" />
          <span data-testid={`catalog-match-badge-${idx}`} className="truncate">{LABEL[m] || LABEL.none}{!bad && row.sku ? ` · ${row.sku}` : ""}</span>
          <ChevronsUpDown className="h-3 w-3 shrink-0 opacity-60" />
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-[460px] border-slate-800 bg-[#F2F2F7] p-0">
        <Command>
          <CommandInput data-testid={`catalog-picker-search-${idx}`} placeholder="Search SKU, product or size…" />
          <CommandList className="max-h-72">
            <CommandEmpty>No catalog items for this door type.</CommandEmpty>
            <CommandGroup>
              {list.map((c) => (
                <CommandItem key={c.id} value={`${c.sku} ${c.product_name} ${c.id}`} data-testid={`catalog-picker-option-${c.id}`}
                  onSelect={() => { onPick(c); setOpen(false); }} className="flex flex-col items-start gap-0.5">
                  <span className="font-mono-num text-xs text-amber-300">{c.sku || "No SKU"}</span>
                  <span className="text-xs text-slate-200">{c.product_name}</span>
                  <span className="text-[10px] text-slate-500">{sizeText(c)}{c.material ? ` · ${c.material}` : ""}</span>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
